/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Contact_TitleInputs */

const en_directory_resources_contact_title = /** @type {(inputs: Directory_Resources_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk to the Seek AI team`)
};

const zh_directory_resources_contact_title = /** @type {(inputs: Directory_Resources_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与 Seek AI 团队沟通`)
};

/**
* | output |
* | --- |
* | "Talk to the Seek AI team" |
*
* @param {Directory_Resources_Contact_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_contact_title = /** @type {((inputs?: Directory_Resources_Contact_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Contact_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_contact_title(inputs)
	return zh_directory_resources_contact_title(inputs)
});
export { directory_resources_contact_title as "directory.resources.contact.title" }